import { create } from 'zustand';

interface TravellerSearchState {
  query: string;
  setQuery: (query: string) => void;
}

/**
 * Holds the most recent traveller search query for the current session so the
 * search page can restore the previous query (and its cached results) when the
 * user navigates back to it. Intentionally not persisted: it lives only for the
 * current app session.
 */
export const useTravellerSearchStore = create<TravellerSearchState>((set) => ({
  query: '',
  setQuery: (query) => set({ query }),
}));
